import moment from 'moment';

export const readableDate = (datestr, label) => {
    if (!datestr) { console.log(`readableDate: ${label}: date ${datestr} is null`); return null; }
    const m = moment(datestr);
    if (!m.isValid()) { console.log(`readableDate: ${label}: date ${datestr} is invalid`); return null; }
    return <div title={`${m.format("MMM DD, YYYY")} at ${m.format("h:mm a z")}`}>{label}: {m.fromNow()}</div>;
}


export const isUSLocale = () => {
    const locale = navigator.language;
    try {
        const format = new Intl.DateTimeFormat(locale, { hour: 'numeric' }).resolvedOptions().hourCycle;
        // Explicitly checks for 24-hour format preferences
        return !(format === 'h23' || format === 'h24');
    } catch (error) {
        console.error("Could not determine locale's time format, defaulting to AM/PM:", error);
        // Default to true for AM/PM if any error occurs or the format can't be recognized
        return true;
    }
};


export const convertToAmPm = (time) => {
    if (time.includes("AM") || time.includes("PM")) {
        return time;
    }
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12; // Converts "00" and "12" appropriately
    return `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
}

// Old Unix-style zone names (tzdata 2024b turned them into links) mapped to the zones they
// now point at. Safari rejects some of them for Intl formatting -- toLocaleDateString with
// timeZone 'CST6CDT' throws "invalid time zone: CST6CDT", and a throw inside a DataGrid
// cell blanks the whole grid (Witches Brew's chat list, 2026-10-13).
const LEGACY_TIME_ZONES = {
    CST6CDT: 'America/Chicago',
    EST5EDT: 'America/New_York',
    MST7MDT: 'America/Denver',
    PST8PDT: 'America/Los_Angeles',
    EST: 'America/Panama',
    MST: 'America/Phoenix',
    HST: 'Pacific/Honolulu',
    CET: 'Europe/Brussels',
    MET: 'Europe/Brussels',
    EET: 'Europe/Athens',
    WET: 'Europe/Lisbon',
};
const displayTimeZoneCache = new Map();

// A zone safe to pass as Intl `timeZone` in this browser: the stored zone (or its modern
// equivalent), else UTC -- never one that throws.
export const displayTimeZone = (tz) => {
    if (!tz) return 'UTC';
    if (!displayTimeZoneCache.has(tz)) {
        const zone = LEGACY_TIME_ZONES[tz] || tz;
        let usable = 'UTC';
        try {
            new Intl.DateTimeFormat('en-US', { timeZone: zone });
            usable = zone;
        } catch (e) {
            console.warn(`displayTimeZone: this browser rejects time zone ${tz}; showing UTC`);
        }
        displayTimeZoneCache.set(tz, usable);
    }
    return displayTimeZoneCache.get(tz);
};
